import { render, staticRenderFns } from "./Mobile-Menu.vue?vue&type=template&id=4063d610&"
import script from "./Mobile-Menu.vue?vue&type=script&lang=ts&"
export * from "./Mobile-Menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports